var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7878b5",
    d: "M5 9l4.183-4.242C9.728 4.21 10 3.543 10 2.754c0-.79-.272-1.457-.817-2.004A2.344 2.344 0 007.428 0c-.69 0-1.274.25-1.755.75L5 1.406 4.351.75C3.871.25 3.281 0 2.584 0 1.887 0 1.298.25.817.75.272 1.297 0 1.965 0 2.754c0 .789.272 1.457.817 2.004z"
  })));
}
export default __webpack_public_path__ + "static/svg/heart.svg";
export { SvgHeart as ReactComponent };